/**
 * Sidebar active-state resolution.
 *
 * Lives in its own module rather than in Sidebar.tsx because exporting a
 * non-component from a component file disables React Fast Refresh for the
 * whole file (react-refresh/only-export-components).
 */

/** Does `pathname` sit at or under `navPath`? Boundary is a path separator. */
function matchesPath(pathname: string, navPath: string): boolean {
  const base = navPath.replace(/\/$/, '')
  return pathname === base || pathname.startsWith(base + '/')
}

/**
 * A nav item is active when the current URL is at or under its path, UNLESS a
 * more specific nav path also matches.
 *
 * Some nav paths are prefixes of others — /marketing precedes /marketing/review
 * and /marketing/templates, /support precedes /support/chat. React Router's
 * NavLink prefix-matches by default, so visiting /marketing/review highlighted
 * BOTH Campaigns and Review Queue.
 *
 * Deliberately not `end` on every link: that fixes the double-highlight but
 * breaks detail routes — /marketing/123 is a campaign detail with no nav entry
 * of its own and must still show Campaigns as active. Longest-match preserves
 * both and needs no per-item annotation, so a future nested route cannot
 * reintroduce the bug by forgetting a flag.
 */
export function isNavItemActive(
  pathname: string,
  navPath: string,
  allPaths: string[]
): boolean {
  if (!matchesPath(pathname, navPath)) return false
  return !allPaths.some(
    (other) => other !== navPath && other.length > navPath.length && matchesPath(pathname, other)
  )
}
